import { Label, TextField } from "components";
import { useExemptionsContext } from "../../ExemptionsContext";
import ButtonV2 from "elements/ButtonV2";
import { PropertyDetailsExemptionFields } from "utils/types";

const SpecialFieldPercentShared = ({
	special_field,
}: {
	special_field: keyof Exclude<
		PropertyDetailsExemptionFields["special_fields"],
		null
	>;
}) => {
	const { next, specialFieldsValue, setSpecialFieldsValue } =
		useExemptionsContext();

	const handleSubmit = async () => {
		next();
	};

	const value = specialFieldsValue?.[special_field] as number;
	const setValue = (v: number | undefined) =>
		setSpecialFieldsValue({ [special_field]: v });

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<div className="property-profile-question-card exemption-survey-card">
				<div className="property-profile-question-card-title-container">
					{special_field === "percent_of_co_op_ownership" && (
						<p>What percent of ownership do you have?</p>
					)}
					{special_field ===
						"percent_of_square_footage_used_as_business_or_rental_property" && (
						<p>
							What percent of square footage is used as a business or rental?
						</p>
					)}
				</div>

				<div className="exemption-special-field-percent-container">
					<div>
						<Label className="exemption-special-field-percent-input-label denim-medium">
							{special_field === "percent_of_co_op_ownership" &&
								"Your Ownership %"}
							{special_field ===
								"percent_of_square_footage_used_as_business_or_rental_property" &&
								"Square Footage %"}
						</Label>
						<div className="exemption-special-field-percent-input-wrapper">
							<TextField
								required
								type="number"
								maxLength={3}
								value={value ?? ""}
								onChange={e => {
									if (
										e.target.value.length <= 3 &&
										Number(e.target.value) <= 100
									) {
										setValue(parseInt(e.target.value));
									}
								}}
							/>
							<p className="exemption-special-field-percent-text">
								{special_field === "percent_of_co_op_ownership" && "% Owner"}
								{special_field ===
									"percent_of_square_footage_used_as_business_or_rental_property" &&
									"% of Square Footage"}
							</p>
						</div>
					</div>
				</div>
			</div>
			<ButtonV2 size="large" disabled={value === undefined} type="submit">
				Continue
			</ButtonV2>
		</form>
	);
};

export const PercentOfSquareFootageUsedAsBusinessOrRentalProperty = () => (
	<SpecialFieldPercentShared special_field="percent_of_square_footage_used_as_business_or_rental_property" />
);

export const PercentOfCoOpOwnership = () => (
	<SpecialFieldPercentShared special_field="percent_of_co_op_ownership" />
);
